import { PropsWithChildren } from "react";
import { PropsWithClassName } from "../../../models/props-with-class-name";
import styles from "./CircleIndicator.module.css";

const CircleIndicator = ({
  className,
  children,
}: PropsWithChildren<PropsWithClassName<{}>>) => {
  return (
    <div className={`${styles.circle} ${className ?? "prim-bg-color"}`}>
      {children}
    </div>
  );
};

export default CircleIndicator;
